import React from 'react';
import { Link } from 'react-router-dom';
import type { FooterLink } from './FooterTypes';
import { isExternalHref, resolveFooterHref } from './FooterUtils';

type FooterLinkItemProps = {
  link: FooterLink;
};

// Renders footer link items

const FooterLinkItem = ({ link }: FooterLinkItemProps): JSX.Element => {
  const href = resolveFooterHref(link);

  return (
    <li className="footer-item">
      {!href ? (
        <span className="footer-link footer-link--disabled">
          {link.label}
        </span>
      ) : isExternalHref(href) ? (
        <a
          className="footer-link"
          href={href}
          target="_blank"
          rel="noreferrer"
        >
          {link.label}
        </a>
      ) : (
        <Link className="footer-link" to={href}>
          {link.label}
        </Link>
      )}
    </li>
  );
};

export default FooterLinkItem;
